module.exports = __webpack_public_path__ + "01216c35ae2256ecb79d83d6043f029c.svg";